import { useMemo } from 'react';

import { LengthRange } from '../types/lengthRange';

const useChunkHash = (ranges: Record<number, LengthRange[]>): Record<number, string> => {
	return useMemo(
		() =>
			Object.keys(ranges).reduce(
				(prev, curr) => ({
					...prev,
					[curr]: ranges[+curr].reduce(
						(previousValue, currentValue) =>
							previousValue + `|${currentValue.depthFrom}::${currentValue.depthTo}`,
						'',
					),
				}),
				{},
			),
		[ranges],
	);
};

export default useChunkHash;
